export interface FileParseRequest {
    /** 任务ID */
    taskId: string;
    /** 内容类型：交底书或权利要求 */
    contentType: 'DISCLOSURE' | 'CLAIM';
    /** 要解析的文件 */
    file: File;
}

export interface ParsedImage {
    /** 图片索引 */
    image_index: number;
    /** 图片名称 */
    image_name: string;
    /** 图片格式 */
    image_format: string;
    /** 图片宽度 */
    width: number;
    /** 图片高度 */
    height: number;
    /** 图片大小（字节） */
    image_size: number;
    /** 图片访问URL */
    image_url: string;
    /** S3存储键 */
    s3_key: string;
    /** 唯一标识符 */
    unique_id: string;
}

export interface DocumentParseResponse {
    /** 解析类型 */
    parse_type: string;
    /** 原始文件名 */
    original_file_name: string;
    /** 文件大小（字节） */
    file_size: number;
    /** 文件类型 */
    file_type: string;
    /** 解析出的文本内容 */
    text_content: string;
    /** 解析出的图片列表 */
    images: ParsedImage[];
    /** 处理状态 */
    status: string;
    /** 处理时间（毫秒） */
    processing_time: number;
}

export const FileParseApi = Symbol.for('FileParseApi');

export interface FileParseApi {
    /**
     * 解析文件内容，提取文本和图片
     * @param request 文件解析请求参数
     * @returns 解析结果
     */
    parseFile(request: FileParseRequest): Promise<DocumentParseResponse>;
}
